import { DSQConflitingMedication } from "@/Common/Api/Dsq/Dto/Responses/DSQConflictingMedications";
import { VigilanceTokenClient } from "@/Common/Api/VigilanceSante/VigilanceTokenClient";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction, IRequestExecutionContext, IResponseExecutionContext } from "@/Common/Stores/Actions/BaseAction";
import { MedicationModel } from "@/Patient/Models/Medication/MedicationModel";
import { MedicationResponse } from "@/Patient/Models/Medication/ResponseModels/MedicationResponse";

class PatientPrescriptionTabActions extends BaseAction {
    constructor(onBeforeExecute?: IRequestExecutionContext, onBeforeHandleResponse?: IResponseExecutionContext) {
        super(onBeforeExecute, onBeforeHandleResponse);
    }

    public ResolveMedicationFromSearch(medicationResponse: MedicationResponse): void {
        var requestData = {
            CodeGen: medicationResponse.CodeGen,
            Form: medicationResponse.Form,
            Strength: medicationResponse.Strength,
            Name: medicationResponse.Name,
            MedicationId: medicationResponse.Id
        };

        return this.Execute(ServerOperations.Server.MedfarDictionary_ResolveMedicationFromSearch, requestData);
    }

    public Prescribe(medicationModel: MedicationModel[], patientId: string, encounterId: string, isFavorite: boolean, sendFax: boolean, printCopy: boolean, signCopy: boolean, withSignature: boolean, prescriptionId: string, dsqDuplicatesConfirmations: DSQConflitingMedication[], generalInstructions: string = null): void {
        const MedicalItemMedicationAndPrescriptions = medicationModel.map(y => y.Model);

        const withDSQ = (patientStore.isDSQActive() == true && sessionStore.DSQPrescriptionDisabled == false && cacheStore.ClinicSettings?.EnableDSQPrescription);

        const requestData = {
            HasSignature: false,
            EncounterId: encounterId,
            PatientContactId: patientId,
            MedicalItemMedicationAndPrescriptions: MedicalItemMedicationAndPrescriptions,
            IsFavorite: isFavorite,
            SendFax: sendFax,
            SignCopy: signCopy,
            PrintCopy: printCopy,
            WithSignature: withSignature,
            PrescriptionId: prescriptionId,
            WithDSQ: withDSQ,
            ConflictingMedications: dsqDuplicatesConfirmations,
            Notes: generalInstructions
        };

        if (requestData.WithDSQ == true) {
            return this.ExecuteDSQ(ServerOperations.Server.Myle_Prescribe, requestData);
        }
        else
            return this.Execute(ServerOperations.Server.Myle_Prescribe, requestData);
    }

    public MedfarDictionnary_GetVigilanceMonographie(codeGen: string, medicalResponseItemId: string): void {
        var requestData = {
            codeGen: codeGen,
            medicalResponseItemId: medicalResponseItemId
        };

        return this.Execute(ServerOperations.Server.MedfarDictionnary_GetVigilanceMonographie, requestData);
    }

    public async RefreshVigilanceAlerts(patientContactId: string, newDrugIdNumbers: string[], interuptedDrugIdNumbers: string[], eventId: string): Promise<void> {
        const token = await VigilanceTokenClient.getVigilanceTokenAsync();

        const requestData = {
            individualId: patientContactId,
            DINs: newDrugIdNumbers,
            ExcludeDINs: interuptedDrugIdNumbers,
            EventId: eventId,
            VigilanceToken: token
        };
        this.Execute(ServerOperations.Server.MedfarDictionnary_GetVigilanceNumberOfAlerts, requestData, null, true);
    }

    public GetVigilanceAnalysis(patientContactId: string, newDrugIdNumbers: string[], interruptedDrugIdNumbers: string[]): void {
        var self = this;

        clearTimeout(patientStore.vigilanceAnalysisDebounceTimeoutReference); // throttle requests

        patientStore.vigilanceAnalysisDebounceTimeoutReference = window.setTimeout(
            async () => {
                const token = await VigilanceTokenClient.getVigilanceTokenAsync();
                self.Execute(
                    ServerOperations.Server.MedfarDictionary_GetVigilanceQueryViewerData,
                    {
                        PatientContactId: patientContactId,
                        DrugIdNumbers: newDrugIdNumbers,
                        ExcludeDrugIdNumbers: interruptedDrugIdNumbers,
                        VigilanceToken: token
                    }
                );
            },
            350
        );
    }
}

export { PatientPrescriptionTabActions };
